import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ed6160f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w_100 text-start text-decoration-underline" }
const _hoisted_2 = { class: "w_150" }
const _hoisted_3 = { class: "w_150" }
const _hoisted_4 = { class: "text-start w_100" }
const _hoisted_5 = { class: "d-flex flex-row" }
const _hoisted_6 = { class: "w_150" }
const _hoisted_7 = {
  key: 0,
  class: "not-seperate-text"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "w_150" }
const _hoisted_10 = {
  key: 0,
  class: "not-seperate-text"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen edit-icon" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-danger" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]

import { translate } from '@/languages/i18n'
import { computed, PropType } from 'vue'
import { numberWithCommas, ReplayName } from '@/constants/common'
import dayjs from 'dayjs'
import { ARTICLE_CELL_ACTION, CREATE_DATE_FORMAT, URL_ARTICLE_EDIT_PATH } from '@/views/community-admin/community-site/constants'
import { useRoute, useRouter } from 'vue-router'
import { COMMUNITY_SITE_ADMIN_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  article: {
    type: Object,
    default: null,
  },
  onCellClick: {
    type: Function as PropType<(article: any, action: ARTICLE_CELL_ACTION) => void>,
  },
  timeNotSeperate: {
    type: Boolean,
    defaul: false,
  },
},
  setup(__props) {

const props = __props

const router = useRouter()
const store = useStore()
const route = useRoute()

const likeClickable = computed(() => props.article.like_count > 0)
const commentClickable = computed(() => props.article.comment_count > 0)



const onLikeClick = () => {
  if (!likeClickable.value) {
    return
  }
  if (props.onCellClick) {
    props.onCellClick(props.article, ARTICLE_CELL_ACTION.LIKE)
  }
}

const onCommentClick = () => {
  if (!commentClickable.value) {
    return
  }
  if (props.onCellClick) {
    props.onCellClick(props.article, ARTICLE_CELL_ACTION.COMMENT)
  }
}

const storeCurrentQuery = async () => {
  await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.STORE_CURRENT_QUERY, route.query)
}

const onEditClick = () => {
  const communityId = router.currentRoute.value.params.id?.toString() ?? ''
  storeCurrentQuery()
  router.push({ path: URL_ARTICLE_EDIT_PATH(communityId, props.article.id) })
}

const onDeleteClick = () => {
  if (props.onCellClick) {
    props.onCellClick(props.article, ARTICLE_CELL_ACTION.DELETE)
  }
}

const onTitleClick = () => {
  props.onCellClick(props.article, ARTICLE_CELL_ACTION.COMMENT)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("span", {
        class: "cursor-pointer",
        onClick: onTitleClick
      }, _toDisplayString(__props.article?.title), 1)
    ]),
    _createElementVNode("td", _hoisted_2, _toDisplayString(__props.article?.published ? _unref(translate)('CK10PublicStatus') : _unref(translate)('CK10PrivateStatus')), 1),
    _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(numberWithCommas)(__props.article?.community_site_view_count) ?? 0), 1),
    _createElementVNode("td", {
      class: _normalizeClass(["w_100", _unref(likeClickable) ? 'text-decoration-underline' : 'text-decoration-none'])
    }, [
      _createElementVNode("span", {
        onClick: onLikeClick,
        class: _normalizeClass({ 'cursor-pointer': _unref(likeClickable) })
      }, _toDisplayString(_unref(numberWithCommas)(__props.article?.like_count) ?? 0), 3)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass(["w_150", _unref(commentClickable) ? 'text-decoration-underline' : 'text-decoration-none'])
    }, [
      _createElementVNode("span", {
        onClick: onCommentClick,
        class: _normalizeClass({ 'cursor-pointer': _unref(commentClickable) })
      }, _toDisplayString(_unref(numberWithCommas)(__props.article?.comment_count) ?? 0), 3)
    ], 2),
    _createElementVNode("td", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _createVNode(UserAliasIcon, {
          userType: __props.article?.user_type
        }, null, 8, ["userType"]),
        _createTextVNode(" " + _toDisplayString(_unref(ReplayName)(__props.article?.is_deleted_in_30_days, __props.article?.available, __props.article?.family_name, __props.article?.given_name, __props.article?.user_type)), 1)
      ])
    ]),
    _createElementVNode("td", _hoisted_6, [
      (__props.timeNotSeperate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.article.created_at ? _unref(dayjs)(__props.article.created_at).format(_unref(CREATE_DATE_FORMAT)) : ''), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.article.created_at ? _unref(dayjs)(__props.article.created_at).format(_unref(CREATE_DATE_FORMAT)) : ''), 1))
    ]),
    _createElementVNode("td", _hoisted_9, [
      (__props.timeNotSeperate)
        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(__props.article.published_date ? _unref(dayjs)(__props.article.published_date).format(_unref(CREATE_DATE_FORMAT)) : '-'), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(__props.article.published_date ? _unref(dayjs)(__props.article.published_date).format(_unref(CREATE_DATE_FORMAT)) : '-'), 1))
    ]),
    _createElementVNode("td", {
      class: "cursor-pointer w_100",
      onClick: onEditClick
    }, _hoisted_13),
    _createElementVNode("td", {
      class: "cursor-pointer w_100",
      onClick: onDeleteClick
    }, _hoisted_15)
  ], 64))
}
}

})